import { render, staticRenderFns } from "./work-permits.vue?vue&type=template&id=656f8b3e&"
import script from "./work-permits.vue?vue&type=script&lang=js&"
export * from "./work-permits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports